import dayjs from "dayjs";
import {
  MONTH_INDEX,
  TAX_YEAR_END,
  TAX_YEAR_END_TYPES,
} from "constants/bookkeeping";
import {
  CALENDAR_YEAR_SHORT,
  FISCAL_YEAR_SHORT,
  TAX_YEAR_SUFFIX,
} from "constants/taxYear";

export type TaxYearPeriod = {
  shortLabel: typeof CALENDAR_YEAR_SHORT | typeof FISCAL_YEAR_SHORT;
  periodLabel: string;
};

const TAX_YEAR_END_VALUES: string[] = Object.values(TAX_YEAR_END);

const isTaxYearEnd = (value: string): value is TAX_YEAR_END_TYPES =>
  TAX_YEAR_END_VALUES.includes(value);

const toMonthAbbr = (month: string): string =>
  dayjs().month(MONTH_INDEX[month]).format("MMM");

export const getTaxYearPeriod = (
  taxYearEnd?: string | null
): TaxYearPeriod | null => {
  if (!taxYearEnd || !isTaxYearEnd(taxYearEnd)) return null;

  const [startMonth, endMonth] = taxYearEnd.split("_");
  const shortLabel =
    taxYearEnd === TAX_YEAR_END.JAN_DEC
      ? CALENDAR_YEAR_SHORT
      : FISCAL_YEAR_SHORT;

  return {
    shortLabel,
    periodLabel: `${toMonthAbbr(startMonth)} - ${toMonthAbbr(
      endMonth
    )} ${TAX_YEAR_SUFFIX}`,
  };
};
